import JSEncrypt from 'jsencrypt';
import { query_everyone_is_asks } from '@/sub-luca-plugin/apis/qa';
import { getQaStore } from '@/sub-luca-plugin/store/qa';
import { IQaRecordItem } from '../qa-records';
import { createGuessYouAskPromise } from '../dialogue-area/index.helper';
import { PUBLIC_KEY, PRIVATE_KEY } from '@/sub-luca-plugin/utils/config';
import { createQaRecordId } from '@/sub-luca-plugin/utils/qa';
import { delay } from '@/sub-luca-plugin/utils';
import { get_bot_key } from '@/sub-luca-plugin/apis';

// 公钥加密
const getEncryption = (data: string) => {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(PUBLIC_KEY);
    const encryptedMessage = encrypt.encrypt(data);
    return encryptedMessage as string;
};

// 私钥解密
const getDecryption = (data: string) => {
    const encrypt = new JSEncrypt();
    encrypt.setPrivateKey(PRIVATE_KEY);
    const encryptedMessage = encrypt.decrypt(data);
    return encryptedMessage as string;
};

// 非对称加密方式，获取加密botKey
export const getBotKey = (botId: string): Promise<string> =>
    new Promise(async resolve => {
        try {
            if (!botId) {
                resolve('');
                return;
            }
            const encryptedBotId = getEncryption(botId);
            if (!encryptedBotId) {
                resolve('');
                return;
            }
            const { status, result } = await get_bot_key({ encryptedBotId });
            if (status === 0 && result) {
                resolve(getDecryption(result));
            } else {
                resolve('');
            }
        } catch (error) {
            resolve('');
        }
    });

export const excuteEveryoneIsAskProcess = (params: Record<string, any>) => {
    const { initResourceType, initResourceId } = params;
    // 题目或视频场景下，具有资源id，则生成大家都在问卡片，有数据则插入欢迎语后，无数据则忽略
    if (![1, 2].includes(initResourceType)) return;
    const { addRequestController, pushQaRecords } = getQaStore()!;
    const source = addRequestController('axios');
    const promise = new Promise<IQaRecordItem[]>(async resolve => {
        try {
            const { result } = await query_everyone_is_asks(
                {
                    resourceType: initResourceType!,
                    resourceId: initResourceId!,
                    pageNum: 1,
                    pageSize: 3,
                },
                { cancelToken: source.token }
            );
            const { list = [], totalSize = 0 } = result || {};
            resolve([
                {
                    recordId: createQaRecordId('respondent'),
                    role: 'respondent',
                    type: 'everyoneIsAsk',
                    asks: result?.list || [],
                    hasNextPage: list.length < totalSize,
                },
            ]);
        } catch (error) {
            resolve([]);
        }
    });
    return async () => {
        const records = await promise;
        if (records.length) {
            pushQaRecords(records);
            await delay(500);
        }
    };
};

export const excuteInitGuessYouAskProcess = (params: Record<string, any>) => {
    const { aiTag, initResourceType, initResourceId } = params;
    // 非AI模式|非题目场景|没有资源id都不执行猜你想问执行流程
    if (aiTag !== 1 || initResourceType !== 2 || !initResourceId) return;
    const { promise } = createGuessYouAskPromise(undefined, {
        recordType: 50,
        lucaId: params.lucaId,
        projectId: params.projectId,
        subjectId: params.subjectId,
        twoLevelSubjectId: params.twoLevelSubjectId,
        guessYouQuestion: { scene: 1, questionId: initResourceId },
    });
    return async () => {
        try {
            const records = await promise;
            if (records.length) {
                getQaStore()!.pushQaRecords(records);
            }
        } catch (error) {}
    };
};
